import axios from "axios";
import { createContext, useContext, useState, useEffect } from "react";

const StateContext = createContext({
    user: null,
    token: null,
    setUser: () => { },
    setToken: () => { },
    counts: { online: 0, offline: 0, trash: 0 },
    countsEtp: { online: 0, offline: 0, trash: 0 },
    updateModuleCounts: () => { },
    ModuleComptes: () => { },
    ModuleComptesEtp: () => { }  
});

export const ContextProvider = ({ children }) => {

    //zone de recherche
    //const [allModules, setAllModules] = useState([]);
   
    const [user, _setUser] = useState(() => {
        const storedUser = localStorage.getItem("USER");
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const [token, _setToken] = useState(() => {
        const storedToken = localStorage.getItem("ACCESS_TOKEN");
        return storedToken || null;
    });

    const [counts, setCounts] = useState({
        online: 0,
        offline: 0,
        trash: 0,
        isLoading: true
    });

     const [countsEtp, setCountsEtp] = useState({
        online: 0,
        offline: 0,
        trash: 0,
        isLoading: true
    });

    const updateModuleCounts = (newCounts) => {
        setCounts(prev => ({
            ...prev,
            ...newCounts
        }));
    };
     const updateModuleCountsEtp = (newCounts) => {
        setCountsEtp(prev => ({
            ...prev,
            ...newCounts
        }));
    };

    const setToken = (token) => {
        _setToken(token);
        if (token) {
            localStorage.setItem("ACCESS_TOKEN", token);
        } else {
            localStorage.removeItem("ACCESS_TOKEN");
        }
    };

    const setUser = (user) => {
        _setUser(user);
        if (user) {
            localStorage.setItem("USER", JSON.stringify(user));
        } else {
            localStorage.removeItem("USER");
        }
    };
    const ModuleComptes = () => {
        if (!token) return;
       console.log("Appel API avec token:", token);

        axios.get('https://catalogue.mg.formafusion.io/api/cfp/modules', {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
            .then(res => {
                const newCounts = {
                    online: res.data.countOnline || 0,
                    offline: res.data.countOffline || 0,
                    trash: res.data.countTrashline || 0
                };
                updateModuleCounts(newCounts);

                // const modules = res.data.modules || [];
                // const taggedModules = modules.map(m => ({...m, source : 'cfp'}));
                // setAllModules (taggedModules);
            })
            .catch(error => {
                console.error("Erreur lors de la récupération des compteurs:", error);
                updateModuleCounts({
                    online: 0,
                    offline: 0,
                    trash: 0
                });
            });
    };

  const ModuleComptesEtp = () => {
        if (!token) return;
       console.log("Appel API avec token:", token);

        axios.get('https://catalogue.mg.formafusion.io/api/entreprise/modules', {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
            .then(res => {
                const newCounts = {
                    online: res.data.countOnline || 0,
                    offline: res.data.countOffline || 0,
                    trash: res.data.countTrashline || 0
                };
                 updateModuleCountsEtp(newCounts);
            })
            .catch(error => {
                console.error("Erreur lors de la récupération des compteurs:", error);
                 updateModuleCountsEtp({
                    online: 0,
                    offline: 0,
                    trash: 0
                });
            });
    };

     useEffect(() => {
        if (token) {
            ModuleComptes();
            ModuleComptesEtp();
        }
    }, [token]);

    return (
       <StateContext.Provider value={{
            user,
            token,
            counts,
            countsEtp,
            setToken,
            setUser,
            updateModuleCounts,
            updateModuleCountsEtp,
            ModuleComptes,
            ModuleComptesEtp,
            //allModules,
        }}>
            {children}
        </StateContext.Provider>
    );
};

export const useStateContext = () => useContext(StateContext);

